export default "__VITE_ASSET__D$GkUf2D__"